import {
  TBaseKeyword,
  TNewOrderCountry,
  TViewsKeyword,
} from "@/entities/new-order";
import { getDatesListFromCountry } from "@/entities/new-order/utils/get-dates-list-from-country";
import { getKeysFromCountry } from "@/entities/new-order/utils/get-keys-from-country";

export function parseViewsToKeywords(countries: TNewOrderCountry[]) {
  const newCountries: TNewOrderCountry[] = countries.map((country) => {
    const oldKeywords: TViewsKeyword = country.keywords as TViewsKeyword;
    const newKeywords: TBaseKeyword = {};

    // Проверяем, что keywords существует и не пустой
    if (!oldKeywords || typeof oldKeywords !== "object") {
      return {
        ...country,
        keywords: newKeywords,
        impressions: undefined,
      };
    }

    const datesList = getDatesListFromCountry(country);
    const keysList = getKeysFromCountry(country);

    // Если нет дат или ключей, возвращаем страну с пустыми keywords
    if (datesList.length === 0 || keysList.length === 0) {
      return {
        ...country,
        keywords: newKeywords,
        impressions: undefined,
      };
    }

    // Преобразуем формат с views обратно в базовый формат
    datesList.forEach((date) => {
      keysList.forEach((key) => {
        if (!newKeywords[date]) {
          newKeywords[date] = {};
        }
        // Безопасное извлечение значения installs
        const keywordData = oldKeywords[date]?.[key];
        newKeywords[date][key] =
          typeof keywordData === "object" && keywordData !== null
            ? (keywordData.installs ?? 0)
            : 0;
      });
    });

    return {
      ...country,
      keywords: newKeywords,
      impressions: undefined,
    };
  });

  return newCountries;
}
